<div *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="takeoffLandArea > 0; else addTitle">Edit Takeoff/Land Area</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <fieldset class="fieldset-container">
        <legend>Area Information</legend>
        <p>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Name *"
                   formControlName="name"
                   [(ngModel)]="takeoffLandArea.name">
          </mat-form-field>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Latitde (Decimal)*"
                   formControlName="latitude"
                   [(ngModel)]="latitude">
          </mat-form-field>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Longitude (Decimal)*"
                   formControlName="longitude"
                   [(ngModel)]="longitude">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-area">
            <mat-select placeholder="Traffic Pattern Dir" [(value)]="selectedTrafficPatternDirection" name="trafficPatternDirection" formControlName="trafficPatternDirection">
              <mat-option value="Left">Left</mat-option>
              <mat-option value="Right">Right</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Elevation (ft)"
                   formControlName="elevation"
                   [(ngModel)]="takeoffLandArea.elevation">
          </mat-form-field>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="True Alignment *"
                   formControlName="trueAlignment"
                   [(ngModel)]="takeoffLandArea.trueAlignment">
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Markings Type"
                   formControlName="markingsType"
                   [(ngModel)]="takeoffLandArea.markingsType">
          </mat-form-field>
          <mat-form-field class="edit-area">
            <mat-select placeholder="Markings Condition *" [(value)]="selectedMarkingsCondition" name="markingsCondition"
                        formControlName="markingsCondition">
              <mat-option value="Poor">Poor</mat-option>
              <mat-option value="Fair">Fair</mat-option>
              <mat-option value="Good">Good</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="edit-area">
            <mat-select placeholder="ILS Type" [(value)]="selectedIlsType" name="ilsType"
                        formControlName="ilsType">
              <mat-option value="ILS">ILS</mat-option>
              <mat-option value="MLS">MLS</mat-option>
              <mat-option value="SDF">SDF</mat-option>
              <mat-option value="Localizer">Localizer</mat-option>
              <mat-option value="LDA">LDA</mat-option>
              <mat-option value="ISMLS">ISMLS</mat-option>
              <mat-option value="ILS/DME">ILS/DME</mat-option>
              <mat-option value="SDF/DME">SDF/DME</mat-option>
              <mat-option value="LOC/DME">LOC/DME</mat-option>
              <mat-option value="LOC/GS">LOC/GS</mat-option>
              <mat-option value="LDA/DME">LDA/DME</mat-option>
            </mat-select>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="edit-area">
            <input matInput
                   placeholder="Gradient"
                   formControlName="gradient"
                   [(ngModel)]="takeoffLandArea.gradient">
          </mat-form-field>
        </p>
      </fieldset>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Takeoff/Land Area
</ng-template>
